<div
  class="toolbar"
  [ngClass]="{
    'toolbar-anim-out': animOut,
    'prek2-reading-toolbar': isPreK2Reading
  }">
  @for (tool of filteredTools; track tool.data.id) {
    <htc-popup-toolbar-button
      [id]="tool.data.id"
      [toolName]="tool.data.toolName"
      [icon]="getToolbarIcon(tool)"
      [toggledIcon]="getToolbarIcon(tool, true)"
      htcAudioClick
      [audioType]="clickType"
      [descriptor]="clickDescriptor"
      [testId]="tool.data.testId"
      [iconSize]="tool.data.iconSize"
      [extraIcon]="{
        icon: tool.data.extraIcon?.icon ?? '',
        toggledIcon: tool.data.extraIcon?.toggledIcon ?? ''
      }"
      [isPreK2Reading]="isPreK2Reading"
      [isDisabled]="shouldDisableToolbar || isActivityCompleteInProgress"
      [hasPK2Avatar]="tool.data.hasPK2Avatar || false"
      [shouldShowVOInProgress]="
        shouldShowVOInProgress(tool)
      "></htc-popup-toolbar-button>
  }
  @if (!isPreK2Reading) {
    @if (shouldShowReadAloudToggle) {
      <htc-read-aloud-toggle></htc-read-aloud-toggle>
    }
  }
</div>
